import { tss } from '@/shared/styles/tss'

export const useStyles = tss.withName('GigiBalance').create(({ theme }) => ({
  balanceTextWrapper: {
    display: 'flex',
    width: 'fit-content',
    flexDirection: 'column',
    gap: '4px',
  },
  balanceTextWrapperProfile: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'cetner',
    justifyContent: 'flex-start',
    gap: '12px',
  },
  gigiTextWrapper: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
    cursor: 'pointer',

    span: {
      fontSize: theme.sizes.texts.fontSize.m,
      fontWeight: 350,
      color: theme.colors.text.secondary,
    },
  },
  gigiTextWrapperProfile: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '4px',
    cursor: 'pointer',

    span: {
      fontSize: theme.sizes.texts.fontSize.s,
      fontWeight: 350,
      color: theme.colors.text.secondary,
    },
  },
}))
